import { ReactNode } from "react";
import PropTypes from "prop-types";
import { HiOutlineLightBulb, HiOutlineMegaphone } from "react-icons/hi2";
import "./information-block.scss";

const baseClassName = "information-block";

interface IInformationBlockProps {
  children: string | ReactNode;
  isSpecial?: boolean;
}

export const InformationBlock = ({
  children,
  isSpecial = false,
}: IInformationBlockProps): JSX.Element => {
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        {!isSpecial && <HiOutlineLightBulb size={20} />}
        {isSpecial && <HiOutlineMegaphone size={20} />}
      </div>
      <p className={`${baseClassName}__paragraph`}>{children}</p>
    </div>
  );
};

InformationBlock.propTypes = {
  children: PropTypes.node.isRequired,
};
